module.exports = __webpack_public_path__ + "img/image-placeholder.a36832a1.png";